import _ from 'lodash';

/**
 * Set the given data with the given name to the local storage.
 * @param {String} name a unique identifier associated with this storage.
 * @param {*} data the data to save to the store.
 */
export function setToStore(name, data) {
	if (typeof data === 'object') {
		data = JSON.stringify(data);
	}
	localStorage.setItem(name, data);
}

/**
 * Gets the data associated with the given name from the local storage.
 * @param {String} name a unique identify used to retrieve the data
 * @returns {*} the retrieved value from the store or null.
 */
export function getFromStore(name) {
	let data = localStorage.getItem(name);
	try {
		return JSON.parse(data);
	} catch (error) {
		return data;
	}
}

/**
 * Removes data with the given name from the local storage.
 * @param {String} name the unique identifier of the data to be removed.
 */
export function removeFromStore(name) {
	localStorage.removeItem(name);
}

export function num2Thousand(num) {
	num = num.toString();
	let parts = num.split('.');
	let arr = parts[0].split('').reverse();
	let tmp = [];
	for (let i = 0, ii = arr.length; i < ii; i++) {
		tmp.push(arr[i]);
		if (i + 1 !== ii && (i + 1) % 3 == 0) {
			tmp.push(',');
		}
	}
	return tmp.reverse().join('') + '.' + (parts[1] || '00');
}

export function isName(str) {
	str = str.trim();
	let RE = /^[a-zA-Z ]*$/i;
	if (str === '') return 'Full name is required';
	if (str.length < 5) return `Name should be 5 characters minimum.`;
	if (str.length > 30) return `Name should be 30 characters maximum.`;
	if (!RE.test(str)) return `Name has invalid characters.`;
	if (!str.includes(' ')) return `Two or more names are required.`;
	return true;
}

export function isPhone(str) {
	str = str.trim();
	if (str.length !== 10 && str.length !== 12) return 'Phone number is invalid. Check Length';
	if (str.length === 10 && str.substr(0, 1) != '0') return 'Phone number is invalid. Start with 0';
	if (str.length === 12 && str.substr(0, 3) != '254') return 'Phone number is invalid. Start with 254';
	if (!/^[0-9]*$/.test(str)) return `Phone number is not valid`;
	return true;
}

export function addKECode(phone) {
	if (phone.length === 12) return phone;
	return '254' + phone.substr(1, 9);
}

export function isEmail(str) {
	str = str.trim();
	let RE = /^[\w-.+]*[\w-_.]@([\w]+\.)+[\w]+[\w]$/i;
	if (str === '') return `Email address is required.`;
	if (str.length < 10) return `Email address is too short.`;
	if (str.length > 60) return `Email address is too long.`;
	if (!RE.test(str)) return `Email address is invalid.`;
	return true;
}

export function isPassword(str) {
	str = str.trim();
	if (str.length < 6) return 'Password should be 6 characters minimum.';
	if (str.length > 30) return 'Password should be 30 characters maximum.';
	if (/^[a-z ]*$/i.test(str)) return 'Password cannot contain letters only.';
	if (/^[0-9 ]*$/i.test(str)) return 'Password cannot contain numbers only.';
	return true;
}

export function isMobile() {
	let check = false;
	(function (a) {
		if (
			/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
				a
			) ||
			/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
				a.substr(0, 4)
			)
		)
			check = true;
	})(navigator.userAgent || navigator.vendor || window.opera);
	return check;
}

export function sortProducts(products, sortBy) {
	return _.chunk(
		sortBy !== 'rand'
			? [...products].sort((a, b) => {
				if (sortBy === 'p_desc') {
					if (parseFloat(a.itemPrice) > parseFloat(b.itemPrice)) {
						return -1;
					} else if (parseFloat(a.itemPrice) < parseFloat(b.itemPrice)) {
						return 1;
					} else {
						return 0;
					}
				} else if (sortBy === 'n_desc') {
					if (a.item_name > b.item_name) {
						return -1;
					} else if (a.item_name < b.item_name) {
						return 1;
					} else {
						return 0;
					}
				} else if (sortBy === 'p_asc') {
					if (parseFloat(a.itemPrice) > parseFloat(b.itemPrice)) {
						return 1;
					} else if (parseFloat(a.itemPrice) < parseFloat(b.itemPrice)) {
						return -1;
					} else {
						return 0;
					}
				} else {
					if (a.item_name > b.item_name) {
						return 1;
					} else if (a.item_name < b.item_name) {
						return -1;
					} else {
						return 0;
					}
				}
			})
			: products,
		30
	);
}

export function setBrandsAndColors(products, setBrands, setColors, setdisplayedbrands) {
	let brandArr = [];
	let colorArr = [];
	products.forEach((item) => {
		if (item.brand && item.brandName) {
			brandArr.push({ brand: item.brand, brandName: item.brandName });
		}
		if (item.color || item.colorName) {
			colorArr.push({ color: item.color, colorName: item.color_name || item.colorName || item.color });
		}
	});

	setBrands(
		brandArr.reduce((unique, current) => {
			if (!unique.some((obj) => obj.brand === current.brand && obj.brandName === current.brandName)) {
				unique.push(current);
			}
			return unique;
		}, [])
	);
	setColors(
		colorArr.reduce((unique, current) => {
			if (!unique.some((obj) => obj.color === current.color && obj.colorName === current.colorName)) {
				unique.push(current);
			}
			return unique;
		}, [])
	);

	if (setdisplayedbrands) {
		setdisplayedbrands(
			brandArr.reduce((unique, current) => {
				if (!unique.some((obj) => obj.brand === current.brand && obj.brandName === current.brandName)) {
					unique.push(current);
				}
				return unique;
			}, [])
		)
	}
}

export function filterByBrandsAndColors(products, brands, colors) {
	if (colors.length > 0) {
		products = products.filter((item) => colors.indexOf(item.color) > -1);
	}
	if (brands.length > 0) {
		products = products.filter((item) => brands.indexOf(item.brand) > -1);
	}
	return products;
}

export function imgCheck(img, alt) {
	return new Promise((resolve, reject) => {
		img = encodeURI(img);
		let image = new Image();
		image.src = img;
		image.onload = function (e) {
			resolve(img);
		};
		image.onerror = function (e) {
			resolve(alt);
		};
	});
}

export function removeHoles(str, count = 0) {
	if (str) {
		str = str.trim();
		str.replace(' ', '');
		str.replace('\n', '');
		if (str.includes(' ') && count < 5) {
			return removeHoles(str, count + 1);
		}
		return str;
	}

}


export const imageurl = (img) => {
	if (!img) return '';
	const url = img.replace(/^https?:\/\/\d{1,3}(\.\d{1,3}){3}:\d{1,5}/, "https://ecommerce-api.maliplus.co.ke");
	return encodeURI(url);
}
